import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
var middleware = [];
if (process.env.NODE_ENV === "development") {
    var createLogger = require("redux-logger").createLogger;
    var logger = createLogger({
        level: "info",
        collapsed: true,
    });
    middleware.push(logger);
}
export var store = configureStore({
    reducer: rootReducer,
    middleware: function (getDefaultMiddleware) {
        var _a;
        return (_a = getDefaultMiddleware()).concat.apply(_a, middleware);
    },
});
